import { InputCheckBox } from "@itandi/itandi-bb-ui/InputCheckBox";
import cx from "clsx";
import type React from "react";
import type { NskResponse } from "~/models/Api";
import type { DealBillingContext } from "~/models/DealBilling";
import type {
	DealSettlement,
	DealSettlementEdit
} from "~/models/DealSettlement";
import Styles from "./SettlementList.module.scss";
import { SettlementListRows } from "./SettlementListRows";

type Props = {
	constructionContext: DealBillingContext;
	handleDestroy: (deleteSettlement: DealSettlement) => Promise<NskResponse>;
	handleMutateSettlements: () => Promise<void>;
	handleUpdate: (
		submitValue: DealSettlementEdit,
		billingId: number
	) => Promise<NskResponse>;
	handleUpdateSeq: (settlements: DealSettlement[]) => Promise<void>;
	onToggleSelect: (id: number) => void;
	onToggleSelectAll: (ids: number[]) => void;
	selectedIds: readonly number[];
	target: "owner" | "rentee";
};
export const SettlementList: React.FC<Props> = ({
	target,
	constructionContext,
	handleMutateSettlements,
	handleUpdate,
	handleDestroy,
	handleUpdateSeq,
	selectedIds,
	onToggleSelect,
	onToggleSelectAll
}: Props) => {
	const allSettlementIds = constructionContext.dealSettlements.map(
		(dealSettlement) => dealSettlement.id
	);
	const isAllSelected =
		allSettlementIds.length > 0 &&
		allSettlementIds.length === selectedIds.length;
	return (
		<div className={Styles.Table}>
			<table className={Styles.List}>
				<thead>
					<tr className={cx(Styles.ListRow, Styles.Header)}>
						<th className={Styles.Select}>
							<InputCheckBox
								checked={isAllSelected}
								onChange={(): void => {
									onToggleSelectAll(allSettlementIds);
								}}
							/>
						</th>
						<th className={Styles.OrderHandle}>並替</th>
						<th className={Styles.Settlement}>精算項目</th>
						<th className={Styles.NonTaxAmount}>金額（税抜）</th>
						<th className={Styles.TaxRate}>税率</th>
						<th className={Styles.TaxAmount}>金額（税込）</th>
						<th className={Styles.Edit} />
					</tr>
				</thead>
				<SettlementListRows
					constructionContext={constructionContext}
					handleDestroy={handleDestroy}
					handleMutateSettlements={handleMutateSettlements}
					handleUpdate={handleUpdate}
					handleUpdateSeq={handleUpdateSeq}
					onToggleSelect={onToggleSelect}
					selectedIds={selectedIds}
					target={target}
				/>
			</table>
		</div>
	);
};
